import { useMemo } from "react";
import { css } from "@emotion/react";

import { staffsArrPC, staffsArrSP } from "../../txts/staff";
import { useIsPC } from "../../hooks";

const Staff: React.FC = () => {
  const isPC = useIsPC();
  const staffsArr = useMemo(() => {
    return isPC ? staffsArrPC : staffsArrSP;
  }, [isPC]);

  return (
    <div css={mainStyle}>
      <div css={contentsWrapperStyle}>
        {staffsArr.map((staffs, idx) => (
          <div key={"staffs" + idx} css={staffsWrapperStyle}>
            {staffs.map((staff, idx) => (
              <div key={"staff" + idx} css={staffStyle}>
                {staff}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const primaryColor = "#D90012";
const spSize = 768;

const mainStyle = css`
  width: 100%;
  background-color: white;
`;

const contentsWrapperStyle = css`
  width: 100%;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${primaryColor};
  font-family: "Noto Sans JP", sans-serif;
  font-size: 13px;
  font-weight: bold;
  text-align: left;

  @media (max-width: ${spSize}px) {
    padding: 15px 0;
    padding-bottom: 10px !important;
    font-size: 9px;
  }
`;

const staffsWrapperStyle = css`
  max-width: 85%;
  padding-top: 0px;
  display: flex;
  flex-wrap: wrap;
`;

const staffStyle = css`
  padding-right: 10px;

  @media (max-width: ${spSize}px) {
    padding-right: 7px;
  }
`;

export default Staff;
